import React from 'react';
import './BannerSkeleton.css';

const BannerSkeleton = () => {
  const items = Array.from({ length: 3 });

  return (
    <div className="banner-skeleton-container">
      {items.map((_, index) => (
        <div key={index} className="banner-skeleton-item">
          <div className="banner-skeleton-preview">
            <div className="banner-skeleton-image"></div>
          </div>
          <div className="banner-skeleton-details">
            <div className="banner-skeleton-info">
              <div className="banner-skeleton-field">
                <div className="banner-skeleton-label"></div>
                <div className="banner-skeleton-value"></div>
              </div>
              <div className="banner-skeleton-field">
                <div className="banner-skeleton-label"></div>
                <div className="banner-skeleton-value"></div>
              </div>
              <div className="banner-skeleton-field">
                <div className="banner-skeleton-label"></div>
                <div className="banner-skeleton-value"></div>
              </div>
              <div className="banner-skeleton-field">
                <div className="banner-skeleton-label"></div>
                <div className="banner-skeleton-value"></div>
              </div>
            </div>
            <div className="banner-skeleton-actions">
              <div className="banner-skeleton-action-btn"></div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default BannerSkeleton;
